import React, { useState } from 'react';

const TheetuCalculator = () => {
  const [eventType, setEventType] = useState('maranam');
  const [personGender, setPersonGender] = useState('male');
  const [maritalStatus, setMaritalStatus] = useState('married');
  const [relation, setRelation] = useState('pangaali_10day');
  const [pregnancyMonth, setPregnancyMonth] = useState('4');

  // Calculate result based on rules matrix from J:\All-theetu-explanation
  const getResult = () => {
    // 1. GARBHASRAVAM (Miscarriage / Abortion)
    if (eventType === 'garbhasravam') {
      const month = parseInt(pregnancyMonth, 10) || 4;
      if (month <= 4) {
        return {
          duration: "தாயாருக்கு 4 நாட்கள் தீட்டு; தகப்பனாருக்கு ஸ்நானம் மாத்திரம்",
          badge: "4 நாட்கள் தீட்டு (4 Days)",
          type: "விச்சித்தி தீட்டு (4-வது மாதம்)",
          color: "bg-amber-50 border-amber-400 text-amber-950",
          details: "கர்ப்பிணியின் 4-வது மாதத்தில் விச்சித்தி ஏற்பட்டால், தகப்பனாருக்கு ஸ்நானம் மாத்திரம். தாயாருக்கு 4 நாட்கள் தீட்டு. பங்காளிகளுக்கு தீட்டு இல்லை.",
          reference: "AbortionTheettu.doc (Sri Paduka Darsanam)"
        };
      } else if (month === 5 || month === 6) {
        return {
          duration: `தாயாருக்கு ${month} நாட்கள் தீட்டு; தகப்பனார் & 10 நாள் பங்காளிகளுக்கு 3 நாட்கள் தீட்டு (அல்லது ஸ்நானம்)`,
          badge: `${month} நாட்கள் தீட்டு (${month} Days)`,
          type: `விச்சித்தி தீட்டு (${month}-வது மாதம்)`,
          color: "bg-amber-100 border-amber-500 text-amber-950",
          details: `${month}-வது மாதத்தில் கடினமான கர்ப்பம் விழுந்தால், தகப்பனார் மற்றும் 10 நாள் பங்காளிகளுக்கு 3 நாட்கள் தீட்டு. நீர்க்குமிழி போல விழுந்தால் ஸ்நானம் மாத்திரம். தாயாருக்கு ${month} நாட்கள் தீட்டு.`,
          reference: "AbortionTheettu.doc"
        };
      } else {
        return {
          duration: "பிதா, மாதா மற்றும் 10 நாள் பங்காளிகளுக்கு 10 நாட்கள் தீட்டு",
          badge: "10 நாட்கள் தீட்டு (10 Days)",
          type: "7-ஆம் மாதம் முதல் விச்சித்தி (Full 10 Days Janana/Marana Rule)",
          color: "bg-red-50 border-red-400 text-red-950",
          details: "7-வது மாதம் முதல் விச்சித்தி ஆனால் முழு தீட்டாகவே கருதப்படும். தகப்பனார், தாயார் மற்றும் 10 நாள் பங்காளிகளுக்கு 10 நாட்கள் தீட்டு. 3 நாள் தீட்டுக்காரர்களுக்கு (ஸமனோதகர்களுக்கு) 3 நாட்கள் தீட்டு.",
          reference: "AbortionTheettu.doc & Shastra Niyamam"
        };
      }
    }

    // 2. SVEEKARAM (Adoption)
    if (eventType === 'sveekaram') {
      if (relation === 'janaka_parents') {
        return {
          duration: "3 நாட்கள் தீட்டு (3 Days)",
          badge: "3 நாட்கள் தீட்டு (3 Days)",
          type: "ஸ்வீகார தத்புத்ரன் - பெற்றோர் மரணம்",
          color: "bg-[#F5EDDA] border-[#CC6600] text-[#1A237E]",
          details: "ஸ்வீகாரமாய் போனவனுக்கு பெற்ற தாய் (ஜநகமாதா) அல்லது பெற்ற தந்தை (ஜநகபிதா) இறந்தால் 3 நாட்கள் தீட்டு. பெற்ற தாய்/தந்தைக்கு ஸ்வீகாரமாய் போன மகன் இறந்தாலும் 3 நாட்கள் தீட்டு.",
          reference: "SveekaramTheettu.doc"
        };
      } else if (relation === 'janaka_brother') {
        return {
          duration: "1 நாள் தீட்டு (1 Day)",
          badge: "1 நாள் தீட்டு (1 Day)",
          type: "ஸ்வீகார தத்புத்ரன் - முன் கோத்திர சகோதரன் மரணம்",
          color: "bg-amber-50 border-amber-400 text-amber-900",
          details: "ஸ்வீகாரமாய் போனவனுக்கு தனது முன் கோத்திரத்து உடன் பிறந்த சகோதரன் இறந்தால் 1 நாள் தீட்டு.",
          reference: "SveekaramTheettu.doc"
        };
      } else {
        return {
          duration: "முழு தீட்டு - 10 நாட்கள் (Full 10 Days)",
          badge: "10 நாட்கள் தீட்டு (10 Days)",
          type: "ஸ்வீகார மாதா / பிதா / தத்புத்ரன் மரணம்",
          color: "bg-red-50 border-red-500 text-red-950",
          details: "ஸ்வீகாரம் செய்து கொண்ட தாய், தந்தை மற்றும் ஸ்வீகார மகன் ஆகியோரின் மரணத்தில் பரஸ்பரம் பெற்ற தாய்/தந்தை/மகன் மரணத்திற்கான முழு தீட்டையே (10 நாட்கள்) அனுஷ்டிக்க வேண்டும்.",
          reference: "SveekaramTheettu.doc"
        };
      }
    }

    // 3. JANANAM (Birth / பிறப்பு தீட்டு)
    if (eventType === 'jananam') {
      if (relation === 'mother_of_child') {
        return {
          duration: relation === 'female_child' ? "40 நாட்கள் சட்டி தொடாமை (40 Days Kitchen Restriction)" : "30 நாட்கள் சட்டி தொடாமை (30 Days Kitchen Restriction)",
          badge: relation === 'female_child' ? "40 நாட்கள் சமையலறை கட்டுப்பாடு" : "30 நாட்கள் சமையலறை கட்டுப்பாடு",
          type: "பிரசவித்த தாயாருக்கு தீட்டு",
          color: "bg-orange-50 border-orange-400 text-orange-950",
          details: "பிரசவித்த தாயார் 10 நாள் தீட்டு முடிந்தாலும் உடனே சமையலறை காரியங்களில் ஈடுபட முடியாது. பெண் குழந்தையானால் 40 நாளும், ஆண் குழந்தையானால் 30 நாளுக்குப் பிறகே சமையலறைக்குச் செல்ல முடியும்.",
          reference: "PirappuTheettu.doc"
        };
      } else if (relation === 'pangaali_10day' || relation === 'father_of_child') {
        return {
          duration: "10 நாட்கள் தீட்டு (10 Days)",
          badge: "10 நாட்கள் தீட்டு (10 Days)",
          type: "தாயாதிகள் / பங்காளிகள் பிறப்பு தீட்டு",
          color: "bg-amber-100 border-amber-500 text-amber-900",
          details: "குழந்தையின் தந்தை, உடன் பிறந்தோர், தகப்பனாரின் சகோதரர்கள் (பெரியப்பா, சித்தப்பா), பிதாமஹர் (தாத்தா) மற்றும் 10 நாள் பங்காளிகளுக்கு 10 நாட்கள் தீட்டு. 10 நாளுக்குப் பின் பிதாவிற்கு ஸ்நானம் மாத்திரமே.",
          reference: "PirappuTheettu.doc"
        };
      } else if (relation === 'maternal_grandparents') {
        return {
          duration: "3 நாட்கள் தீட்டு (3 Days)",
          badge: "3 நாட்கள் தீட்டு (3 Days)",
          type: "மாதாமஹன் / மாதாமஹி (தாயின் பெற்றோர்)",
          color: "bg-yellow-50 border-yellow-500 text-yellow-900",
          details: "மகள் குழந்தை பெற்றால், குழந்தையின் தாய் வழி பாட்டனார் (மாதாமஹர்) மற்றும் பாட்டிக்கு 3 நாட்கள் தீட்டு.",
          reference: "PirappuTheettu.doc"
        };
      } else if (relation === 'delivery_sponsor') {
        return {
          duration: "1 நாள் தீட்டு (1 Day)",
          badge: "1 நாள் தீட்டு (1 Day)",
          type: "பிரசவச் செலவு ஏற்ற தாய்வழி உறவினர்",
          color: "bg-blue-50 border-blue-400 text-blue-900",
          details: "தாயின் சகோதரன் (மாமா), பெரியப்பா, சித்தப்பா ஆகியோருக்கு தீட்டு இல்லை. ஆனால் பிரசவம் யாருடைய பொருட்செலவில் நடந்ததோ அவருக்கு 1 நாள் தீட்டு உண்டு.",
          reference: "PirappuTheettu.doc"
        };
      } else {
        return {
          duration: "தீட்டு இல்லை (No Theetu)",
          badge: "தீட்டு இல்லை (No Theetu)",
          type: "இதர தாய்வழி உறவினர்கள்",
          color: "bg-green-50 border-green-500 text-green-950",
          details: "குழந்தை பெற்றவளின் சகோதரன், மாமா, பெரியப்பா போன்றவர்களுக்கு தீட்டு இல்லை (பிரசவச் செலவு ஏற்காத பட்சத்தில்).",
          reference: "PirappuTheettu.doc"
        };
      }
    }

    // 4. MARANAM (Death / இறப்பு தீட்டு)
    // Married Female Rules:
    if (personGender === 'female' && maritalStatus === 'married') {
      if (relation === 'pangaali_10day' || relation === 'husband_pangaali') {
        return {
          duration: "10 நாட்கள் தீட்டு (10 Days - Husband's Lineage)",
          badge: "10 நாட்கள் தீட்டு (10 Days)",
          type: "கணவரின் 10 நாள் பங்காளி இறப்பு",
          color: "bg-red-50 border-red-500 text-red-950",
          details: "முக்கிய விதி: திருமணமான பெண்ணிற்கு தீட்டு பார்க்கும் முன், இவருக்கு கணவருக்கு தீட்டு உண்டா என்று பார்க்க வேண்டும். கணவருக்கு 10 நாள் தீட்டு இருந்தால், மனைவிக்கும் 10 நாள் தீட்டே உண்டு.",
          reference: "Female_Married Rules (J:\\All-theetu-explanation)"
        };
      }
      if (relation === 'mother' || relation === 'father') {
        return {
          duration: "3 நாட்கள் தீட்டு (3 Days)",
          badge: "3 நாட்கள் தீட்டு (3 Days)",
          type: "திருமணமான பெண் - பெற்ற தாய் / தந்தை இறப்பு",
          color: "bg-amber-100 border-amber-500 text-amber-900",
          details: "திருமணமான பெண்ணிற்கு பெற்ற தாய் அல்லது பெற்ற தந்தை இறந்தால் 3 நாட்கள் தீட்டு.",
          reference: "Female_Married_Male_Upanayanam.doc"
        };
      }
      if (relation === 'brother' || relation === 'sister' || relation === 'nephew') {
        return {
          duration: "பக்ஷிணீ - 1.5 நாட்கள் (1.5 Days / Pakshini)",
          badge: "பக்ஷிணீ 1.5 நாள் (1.5 Days)",
          type: "திருமணமான பெண் - சகோதரன் / சகோதரி / மருமான் இறப்பு",
          color: "bg-[#F5EDDA] border-[#CC6600] text-[#1A237E]",
          details: "கணவனுக்கு தீட்டு இல்லாத நிலையில், திருமணமான பெண்ணிற்கு உடன் பிறந்த சகோதரன், சகோதரி, அல்லது சகோதரனின் குழந்தை இறந்தால் பக்ஷிணீ (ஒன்றரை நாள்) தீட்டு.",
          reference: "Female_Married_Female_Married.doc"
        };
      }
      if (relation === 'maternal_grandmother' || relation === 'aunt_paternal' || relation === 'aunt_maternal') {
        return {
          duration: "பக்ஷிணீ - 1.5 நாட்கள் (1.5 Days / Pakshini)",
          badge: "பக்ஷிணீ 1.5 நாள் (1.5 Days)",
          type: "திருமணமான பெண் - அத்தை / சித்தி / பாட்டி இறப்பு",
          color: "bg-amber-50 border-amber-400 text-amber-900",
          details: "தாயின் தாய் (மாதாமஹி), தந்தையின் சகோதரி (அத்தை), தாயின் சகோதரி (சித்தி/பெரியம்மா) இறந்தால் பக்ஷிணீ (1.5 நாள்) தீட்டு.",
          reference: "Female_Married_Female_Married.doc"
        };
      }
    }

    // Unmarried Female Rules
    if (personGender === 'female' && maritalStatus === 'unmarried') {
      if (relation === 'pangaali_10day' || relation === 'father' || relation === 'mother' || relation === 'brother') {
        return {
          duration: "10 நாட்கள் தீட்டு (10 Days)",
          badge: "10 நாட்கள் தீட்டு (10 Days)",
          type: "திருமணமாகாத பெண் - தகப்பனார் / பங்காளி இறப்பு",
          color: "bg-red-50 border-red-500 text-red-950",
          details: "திருமணமாகாத பெண்ணிற்கு தனது தகப்பனார், தாய், உடன் பிறந்த சகோதரன் அல்லது 10 நாள் பங்காளிகள் இறந்தால் 10 நாட்கள் தீட்டு.",
          reference: "Theettu for Unmarried Female.doc"
        };
      } else {
        return {
          duration: "தீட்டு இல்லை (No Theetu)",
          badge: "தீட்டு இல்லை (No Theetu)",
          type: "திருமணமாகாத பெண் - இதர உறவினர்",
          color: "bg-green-50 border-green-500 text-green-950",
          details: "திருமணமாகாத பெண்ணிற்கு தகப்பனார் வழி பங்காளிகள் மற்றும் தாய்/தந்தை தவிர மற்றவர்களின் இறப்பில் தீட்டு இல்லை.",
          reference: "Theettu for Unmarried Female.doc"
        };
      }
    }

    // Unmarried Male (Brahmachari)
    if (personGender === 'male' && maritalStatus === 'unmarried') {
      if (relation === 'father' || relation === 'mother' || relation === 'elder_brother') {
        return {
          duration: "10 நாட்கள் தீட்டு (10 Days)",
          badge: "10 நாட்கள் தீட்டு (10 Days)",
          type: "பிரம்மசாரி - தாய் / தந்தை / மூத்த சகோதரன் இறப்பு",
          color: "bg-red-50 border-red-500 text-red-950",
          details: "பிரம்மசாரிக்கு (உபநயனமானவர்) மாதா, பிதா, மூத்த சகோதரன் ஆகிய மூவரின் மரணத்தில் மட்டுமே 10 நாள் தீட்டும், க்ஷவரமும், தர்ப்பணமும் உண்டு.",
          reference: "TheettuForBrahmacharis.doc"
        };
      } else if (relation === 'pangaali_10day') {
        return {
          duration: "3 நாட்கள் தீட்டு அல்லது ஸ்நானம் (3 Days / Snanam)",
          badge: "3 நாட்கள் தீட்டு (3 Days)",
          type: "பிரம்மசாரி - இதர பங்காளிகள்",
          color: "bg-amber-50 border-amber-400 text-amber-900",
          details: "பிரம்மசாரிகளுக்கு மாதா, பிதா, மூத்த சகோதரன் தவிர மற்ற பங்காளிகள் இறந்தால் க்ஷவரமும் தர்ப்பணமும் இல்லை, ஸ்நானம் / 3 நாள் தீட்டு மாத்திரமே.",
          reference: "TheettuForBrahmacharis.doc"
        };
      }
    }

    // Married Male Rules
    if (relation === 'pangaali_10day' || relation === 'father' || relation === 'mother' || relation === 'son') {
      return {
        duration: "10 நாட்கள் தீட்டு (10 Days)",
        badge: "10 நாட்கள் தீட்டு (10 Days)",
        type: "10 நாள் தாயாதிகள் / பங்காளிகள்",
        color: "bg-red-50 border-red-500 text-red-950",
        details: "தந்தை, தாய், மகன், உடன் பிறந்த சகோதரன், சித்தப்பா, பெரியப்பா மற்றும் 7 தலைமுறைக்குட்பட்ட தந்தை வழி பங்காளிகள் (தாயாதிகள்) இறந்தால் 10 நாட்கள் தீட்டு.",
        reference: "Male_Married_Male_Upanayanam.doc & PangaliList.doc"
      };
    } else if (relation === 'pangaali_7gen_plus') {
      return {
        duration: "3 நாட்கள் தீட்டு (3 Days)",
        badge: "3 நாட்கள் தீட்டு (3 Days)",
        type: "7 தலைமுறைக்கு மேற்பட்ட பங்காளி (ஸமானோதகர்கள்)",
        color: "bg-amber-100 border-amber-500 text-amber-900",
        details: "7 தலைமுறைக்கு மேற்பட்ட பங்காளி (ஸமானோதகர்) அல்லது அவரது மனைவி இறந்தால் 3 நாட்கள் தீட்டு.",
        reference: "Male_Married_Male_Upanayanam.doc"
      };
    } else if (relation === 'maternal_uncle' || relation === 'maternal_grandfather' || relation === 'mother_sister' || relation === 'paternal_aunt' || relation === 'sister' || relation === 'nephew' || relation === 'grandson_daughter') {
      return {
        duration: "3 நாட்கள் தீட்டு (3 Days)",
        badge: "3 நாட்கள் தீட்டு (3 Days)",
        type: "தாய்மாமன் / மாதாமஹர் / சகோதரி / மருமான் / தௌஹித்ரன்",
        color: "bg-amber-100 border-amber-500 text-amber-900",
        details: "தாயின் தந்தை (மாதாமஹர்), மாமா, தாயின் சகோதரி (சித்தி/பெரியம்மா), தந்தையின் சகோதரி (அத்தை), சகோதரி, சகோதரியின் மகன் (மருமான்), மகள் வயிற்றுப் பேரன் (தௌஹித்ரன்) இறந்தால் 3 நாட்கள் தீட்டு.",
        reference: "Male_Married_Male_Upanayanam.doc"
      };
    } else if (relation === 'father_in_law') {
      return {
        duration: "3 நாட்கள் தீட்டு (3 Days) அல்லது 1 நாள் (1 Day)",
        badge: "3 நாட்கள் / 1 நாள் தீட்டு",
        type: "மாமனார் / மாமியார்",
        color: "bg-[#F5EDDA] border-[#CC6600] text-[#1A237E]",
        details: "மாமனார்/மாமியார் இறப்பில்: தீட்டுக்காரரின் மனைவி அல்லது சந்ததி (அல்லது இருவரும்) உயிருடன் இருந்தால் 3 நாட்கள் தீட்டு. மனைவி மற்றும் சந்ததி இருவரும் இல்லையெனில் 1 நாள் தீட்டு.",
        reference: "Male_Married_Male_Upanayanam.doc"
      };
    } else if (relation === 'cousin_ammanji' || relation === 'cousin_atthan') {
      return {
        duration: "பக்ஷிணீ - 1.5 நாட்கள் (1.5 Days / Pakshini)",
        badge: "பக்ஷிணீ 1.5 நாள் (1.5 Days)",
        type: "அம்மாஞ்சி / அத்தான் / அத்தங்கா",
        color: "bg-amber-50 border-amber-400 text-amber-900",
        details: "மாமா பிள்ளை (அம்மாஞ்சி), அத்தை பிள்ளை (அத்தான்), அத்தை மகள் (அத்தங்கா), சித்தி/பெரியம்மா பிள்ளை இறந்தால் பக்ஷிணீ (ஒன்றரை நாள்) தீட்டு.",
        reference: "Male_Married_Male_Upanayanam.doc"
      };
    } else if (relation === 'sapathni_brother' || relation === 'sapathni_mother') {
      return {
        duration: "1 நாள் தீட்டு (1 Day)",
        badge: "1 நாள் தீட்டு (1 Day)",
        type: "ஸபத்னி உறவினர்கள் (மறுமனைவி வழி உறவு)",
        color: "bg-amber-50 border-amber-400 text-amber-900",
        details: "தந்தையின் வேறு மனைவிக்குப் பிறந்த சகோதரன் (பின்னோதர ப்ராதா), ஸபத்னி மாதாவின் சகோதரன்/தந்தை இறந்தால் 1 நாள் தீட்டு.",
        reference: "Sapathni_Male_Married_Male_Upanayanam.doc"
      };
    } else {
      return {
        duration: "தீட்டு இல்லை (No Theetu)",
        badge: "தீட்டு இல்லை (No Theetu)",
        type: "சகோதரியின் கணவன் / மைத்துனன் / ஷட்டகர்",
        color: "bg-green-50 border-green-500 text-green-950",
        details: "மகளின் கணவன் (மாப்பிள்ளை), சகோதரியின் கணவன் (அத்திம்பேர்), மனைவியின் சகோதரன் (மைத்துனன்), மனைவியின் சகோதரி கணவன் (ஷட்டகர்) ஆகியோரின் இறப்பில் தீட்டு இல்லை.",
        reference: "Male_Married_Male_Upanayanam.doc"
      };
    }
  };

  const res = getResult();

  return (
    <div className="theetu-calculator-wrapper bg-[#FAF6EE] rounded-3xl shadow-xl border-2 border-[#D4AF37] p-5 md:p-8 my-8 font-sans">
      
      {/* Title Header */}
      <div className="flex items-center space-x-3 pb-4 mb-6 border-b-2 border-amber-200">
        <span className="text-3xl">🧮</span>
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-[#1A237E]">
            ஆசௌசம் (தீட்டு) துல்லிய கணிப்பான்
          </h2>
          <p className="text-xs md:text-sm text-[#CC6600] font-semibold">
            (ஸ்ரீ பாதுகா தர்சனம் & NVS ஸ்வாமி தர்ம சாஸ்திர நிர்ணயப்படி அமைந்தது)
          </p>
        </div>
      </div>

      <div className="space-y-6">

        {/* STEP 1: EVENT TYPE SELECTOR CARDS */}
        <div>
          <label className="block text-xs font-bold uppercase tracking-wider text-amber-900 mb-2">
            1. நிகழ்வு வகை (Event Type):
          </label>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {[
              { id: 'maranam', icon: '⚰️', title: 'இறப்பு தீட்டு', sub: 'Marana Theetu' },
              { id: 'jananam', icon: '👶', title: 'பிறப்பு தீட்டு', sub: 'Janana Theetu' },
              { id: 'garbhasravam', icon: '🤰', title: 'கர்ப்பச்சிதைவு', sub: 'Miscarriage' },
              { id: 'sveekaram', icon: '🏡', title: 'ஸ்வீகாரம்', sub: 'Adoption' }
            ].map((evt) => (
              <button
                key={evt.id}
                type="button"
                onClick={() => setEventType(evt.id)}
                className={`p-3 md:p-4 rounded-2xl border-2 text-left transition-all flex flex-col justify-between ${
                  eventType === evt.id
                    ? 'bg-[#1A237E] text-amber-100 border-[#D4AF37] shadow-lg scale-[1.02]'
                    : 'bg-white text-gray-800 border-amber-200 hover:border-[#CC6600]'
                }`}
              >
                <span className="text-2xl mb-1">{evt.icon}</span>
                <div>
                  <div className="font-bold text-sm leading-tight">{evt.title}</div>
                  <div className="text-[11px] opacity-80 font-medium">{evt.sub}</div>
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* STEP 2: PERSON PROFILE SEGMENTED BUTTONS */}
        <div className="bg-white p-4 rounded-2xl border border-amber-200 shadow-xs space-y-4">
          <label className="block text-xs font-bold uppercase tracking-wider text-amber-900">
            2. தீட்டு பார்க்க விரும்புபவரின் விவரம் (Affected Person Profile):
          </label>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            
            {/* Gender Toggle */}
            <div className="space-y-1.5">
              <span className="text-xs font-semibold text-gray-600 block">பாலினம் (Gender):</span>
              <div className="grid grid-cols-2 gap-2 bg-[#FAF6EE] p-1.5 rounded-xl border border-amber-200">
                <button
                  type="button"
                  onClick={() => setPersonGender('male')}
                  className={`py-2 px-3 rounded-lg text-xs md:text-sm font-bold transition-all ${
                    personGender === 'male'
                      ? 'bg-[#CC6600] text-white shadow-sm'
                      : 'text-gray-700 hover:text-[#1A237E]'
                  }`}
                >
                  👨 ஆண் (Male)
                </button>
                <button
                  type="button"
                  onClick={() => setPersonGender('female')}
                  className={`py-2 px-3 rounded-lg text-xs md:text-sm font-bold transition-all ${
                    personGender === 'female'
                      ? 'bg-[#CC6600] text-white shadow-sm'
                      : 'text-gray-700 hover:text-[#1A237E]'
                  }`}
                >
                  👩 பெண் (Female)
                </button>
              </div>
            </div>

            {/* Marital Status Toggle */}
            <div className="space-y-1.5">
              <span className="text-xs font-semibold text-gray-600 block">திருமண நிலை (Marital Status):</span>
              <div className="grid grid-cols-2 gap-2 bg-[#FAF6EE] p-1.5 rounded-xl border border-amber-200">
                <button
                  type="button"
                  onClick={() => setMaritalStatus('married')}
                  className={`py-2 px-3 rounded-lg text-xs md:text-sm font-bold transition-all ${
                    maritalStatus === 'married'
                      ? 'bg-[#1A237E] text-white shadow-sm'
                      : 'text-gray-700 hover:text-[#1A237E]'
                  }`}
                >
                  💍 திருமணமானவர்
                </button>
                <button
                  type="button"
                  onClick={() => setMaritalStatus('unmarried')}
                  className={`py-2 px-3 rounded-lg text-xs md:text-sm font-bold transition-all ${
                    maritalStatus === 'unmarried'
                      ? 'bg-[#1A237E] text-white shadow-sm'
                      : 'text-gray-700 hover:text-[#1A237E]'
                  }`}
                >
                  🌱 திருமணமாகாதவர்
                </button>
              </div>
            </div>

          </div>
        </div>

        {/* STEP 3: RELATIONSHIP SELECTOR (FULL WIDTH) */}
        <div>
          <label className="block text-xs font-bold uppercase tracking-wider text-amber-900 mb-1.5">
            3. இறந்தவர் / பிறந்தவர் என்ன உறவு? (Select Relationship):
          </label>

          {eventType === 'garbhasravam' ? (
            <select 
              value={pregnancyMonth} 
              onChange={(e) => setPregnancyMonth(e.target.value)}
              className="w-full p-3.5 bg-white border-2 border-[#D4AF37] rounded-2xl font-bold text-[#1A237E] text-sm md:text-base shadow-xs focus:outline-none focus:border-[#CC6600]"
            >
              <option value="4">4-வது மாதம் (4th Month Miscarriage)</option>
              <option value="5">5-வது மாதம் (5th Month Miscarriage)</option>
              <option value="6">6-வது மாதம் (6th Month Miscarriage)</option>
              <option value="7">7-வது மாதம் அல்லது அதற்கு மேல் (7th+ Month)</option>
            </select>
          ) : eventType === 'jananam' ? (
            <select 
              value={relation} 
              onChange={(e) => setRelation(e.target.value)}
              className="w-full p-3.5 bg-white border-2 border-[#D4AF37] rounded-2xl font-bold text-[#1A237E] text-sm md:text-base shadow-xs focus:outline-none focus:border-[#CC6600]"
            >
              <option value="pangaali_10day">10 நாள் பங்காளி / குழந்தை தந்தை (10-Day Dayadi)</option>
              <option value="mother_of_child">குழந்தை பெற்ற தாயார் (Mother of Born Child)</option>
              <option value="maternal_grandparents">தாயின் பெற்றோர் (மாதாமஹர் / மாதாமஹி)</option>
              <option value="delivery_sponsor">பிரசவச் செலவு ஏற்ற தாய்வழி உறவினர்</option>
              <option value="other_relatives">இதர தாய்வழி உறவினர்கள் (மாமா, சகோதரன்)</option>
            </select>
          ) : eventType === 'sveekaram' ? (
            <select 
              value={relation} 
              onChange={(e) => setRelation(e.target.value)}
              className="w-full p-3.5 bg-white border-2 border-[#D4AF37] rounded-2xl font-bold text-[#1A237E] text-sm md:text-base shadow-xs focus:outline-none focus:border-[#CC6600]"
            >
              <option value="janaka_parents">பெற்ற தாய் / பெற்ற தந்தை (Janaka Parents)</option>
              <option value="janaka_brother">முன் கோத்திர உடன் பிறந்த சகோதரன் (Janaka Brother)</option>
              <option value="sveekara_parents">ஸ்வீகார தாய் / தந்தை / ஸ்வீகார மகன் (Adoptive Lineage)</option>
            </select>
          ) : (
            <select 
              value={relation} 
              onChange={(e) => setRelation(e.target.value)}
              className="w-full p-3.5 bg-white border-2 border-[#D4AF37] rounded-2xl font-bold text-[#1A237E] text-sm md:text-base shadow-xs focus:outline-none focus:border-[#CC6600]"
            >
              <option value="pangaali_10day">10 நாள் பங்காளி / தந்தை / தாய் / மகன் / சகோதரன்</option>
              <option value="pangaali_7gen_plus">7 தலைமுறைக்கு மேற்பட்ட பங்காளி (ஸமானோதகர்கள் - 3 நாள்)</option>
              <option value="maternal_uncle">தாயின் சகோதரன் (மாமா / தாய்மாமன் - 3 நாள்)</option>
              <option value="maternal_grandfather">தாயின் தந்தை (மாதாமஹர்) / பாட்டி (3 நாள்)</option>
              <option value="paternal_aunt">தந்தையின் சகோதரி (அத்தை - 3 நாள் / 1.5 நாள்)</option>
              <option value="mother_sister">தாயின் சகோதரி (சித்தி / பெரியம்மா - 3 நாள்)</option>
              <option value="sister">உடன் பிறந்த சகோதரி (3 நாள் / 1.5 நாள்)</option>
              <option value="nephew">சகோதரியின் மகன் (மருமான்) / மகள் வயிற்றுப் பேரன் (3 நாள்)</option>
              <option value="father_in_law">மாமனார் / மாமியார் (3 நாள் / 1 நாள்)</option>
              <option value="cousin_ammanji">மாமா பிள்ளை (அம்மாஞ்சி) / அத்தை பிள்ளை (அத்தான் - பக்ஷிணீ 1.5 நாள்)</option>
              <option value="sapathni_brother">ஸபத்னி உறவினர்கள் (மறுமனைவி வழி சகோதரன் - 1 நாள்)</option>
              <option value="in_laws_others">மகளின் கணவன் (மாப்பிள்ளை) / மைத்துனன் / அத்திம்பேர் / ஷட்டகர் (தீட்டு இல்லை)</option>
            </select>
          )}
        </div>

        {/* STEP 4: ELEGANT RESULT DISPLAY CARD */}
        <div className={`p-6 rounded-3xl border-2 shadow-lg transition-all duration-300 ${res.color}`}>
          
          <div className="flex flex-wrap items-center justify-between gap-2 border-b border-black/10 pb-3 mb-4">
            <span className="text-xs uppercase font-bold tracking-wider opacity-80">
              கணக்கீட்டு முடிவு (Result):
            </span>
            <span className="text-xs font-bold px-3 py-1 bg-white/80 rounded-full shadow-2xs text-[#1A237E] border border-amber-300">
              {res.type}
            </span>
          </div>

          {/* Large Result Badge */}
          <div className="mb-4 inline-block bg-[#1A237E] text-amber-200 px-5 py-2 rounded-2xl font-extrabold text-lg md:text-xl shadow-md border border-[#D4AF37]">
            ⏱️ {res.badge}
          </div>

          <h3 className="text-base md:text-lg font-bold text-gray-900 mb-2 leading-snug">
            {res.duration}
          </h3>
          
          <p className="text-sm md:text-base text-gray-800 leading-relaxed font-medium mb-4">
            {res.details}
          </p>

          <div className="text-xs opacity-75 pt-3 border-t border-black/10 flex flex-wrap items-center justify-between gap-2">
            <span>ஆதார நூல்: <strong className="font-semibold">{res.reference}</strong></span>
            <span className="font-semibold text-[#CC6600]">ஆசௌச தர்ம சாஸ்திர நிர்ணயம்</span>
          </div>

        </div>

      </div>
    </div>
  );
};

export default TheetuCalculator;
